import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { Modal } from 'react-bootstrap';
import useRedirectLoggedOutUser from "../customHook/useRedirectLoggedOutUser";
import { useDispatch, useSelector } from "react-redux";
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import {
	getLoginStatus, selectIsLoggedIn, login, RESET
} from "../redux/features/auth/authSlice";

const meetingUrl = process.env.REACT_APP_BACKEND_URL;
const appID = Number(process.env.REACT_APP_ID_ZEGO);
const serverSecret = process.env.REACT_APP_SECRET_KEY_ZEGO;

const initialState = {
	email: "",
	password: "",
};

const Room = () => {

	// useRedirectLoggedOutUser("/login");

	const [show, setShow] = useState(false);

	const showPassword = () => setShow(!show);

	const [formData, setFormData] = useState(initialState);
	const { email, password } = formData;
	const { roomId } = useParams();
	const { user, isLoading, isSuccess } = useSelector((state) => state.auth);
	const [ViewLoginModel, SetLoginModelShow] = useState(false)
	const handleLoginModelShow = () => { SetLoginModelShow(true) }
	const hanldeLoginModelClose = () => { SetLoginModelShow(false) }

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const isLoggedIn = useSelector(selectIsLoggedIn);
	// console.log(user);
	// useEffect(() => {
	//     if (user) {
	//       	SetLoginModelShow(false);
	//       }else {
	//           SetLoginModelShow(true);
	//       }

	// }, [user]);

	useEffect(() => {
		if (!user) {
			// If the user is not logged in, show the login modal
			handleLoginModelShow();
		} else {
			// If the user is logged in, join the meeting
			const element = document.querySelector(".myCallContainer");
			if (element) {
				myMeeting(element);
			}
		}
	}, [user]);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	}

	const loginUser = async (e) => {
		e.preventDefault();

		if (!email || !password) {
			return toast.error("All fields are required");
		}

		const userData = {
			email,
			password,
		};

		// console.log(userData);
		await dispatch(login(userData));
	}

	useEffect(() => {
		if (isSuccess && isLoggedIn) {
			hanldeLoginModelClose();
		}
		dispatch(RESET());
	}, [isLoggedIn, isSuccess, dispatch])

	// Track call end and update duration
	useEffect(() => {
		const handleCallEnd = () => {
			console.log('🔍 handleCallEnd triggered');
			const activeCall = sessionStorage.getItem('activeCallLog');
			console.log('🔍 activeCallLog from sessionStorage:', activeCall);

			if (activeCall) {
				const { callLogId, startTime, otherUserId } = JSON.parse(activeCall);
				const duration = Math.floor((Date.now() - startTime) / 1000); // seconds

				console.log(`📴 Ending call. CallLogId: ${callLogId}, Duration: ${duration}s, StartTime: ${new Date(startTime).toISOString()}`);

				const payload = {
					callLogId,
					status: 'answered',  // Changed from 'ended' - all completed calls are 'answered'
					endTime: new Date().toISOString(),
					duration,
				};

				console.log('📤 Sending duration update with payload:', payload);

				// Try sendBeacon first (most reliable for page unload)
				if (navigator.sendBeacon) {
					const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
					const sent = navigator.sendBeacon(`${meetingUrl}/api/calllogs/duration`, blob);
					console.log('📡 sendBeacon sent:', sent);
				}

				// Also try fetch as backup
				fetch(`${meetingUrl}/api/calllogs`, {
					method: 'PUT',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(payload),
					keepalive: true,
					credentials: 'include'
				})
					.then(response => {
						console.log('✅ Duration update response status:', response.status);
						return response.json();
					})
					.then(data => {
						console.log('✅ Duration update response data:', data);
					})
					.catch(err => {
						console.error('❌ Failed to update call log:', err);
					});

				// If duration is very short (e.g. < 5s) and we have otherUserId, 
				// it might be a cancellation or quick hangup.
				// We emit 'cancel call' to ensure the other side stops ringing if they haven't answered.
				// The backend/frontend should handle this gracefully even if already answered.
				if (otherUserId) {
					// We need a socket instance here. 
					// Since Room.js doesn't have the socket prop directly passed easily without context,
					// we might need to rely on the backend handling the 'end call' or we can try to get socket from context if available.
					// However, for now, let's assume the user closes the tab, so socket disconnects.
					// The backend handles disconnect, but doesn't know it's a cancel.

					// Ideally we should emit an event. But socket might be disconnecting.
					// We can try to use navigator.sendBeacon to a backend endpoint that emits the socket event?
					// Or just rely on the fact that if we are here, the component is unmounting.

					// Let's try to emit if socket is available. 
					// But wait, Room.js doesn't have 'socket' in props in the current file content I saw.
					// It uses ZegoUIKit.
				}

				sessionStorage.removeItem('activeCallLog');
				console.log('🗑️ Removed activeCallLog from sessionStorage');
			} else {
				console.log('⚠️ No activeCallLog found in sessionStorage');
			}
		};

		// Add beforeunload listener for extra reliability
		const handleBeforeUnload = (e) => {
			console.log('⚠️ beforeunload event triggered');
			handleCallEnd();
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		// Handle component unmount
		return () => {
			console.log('🔄 Room component unmounting - calling handleCallEnd');
			window.removeEventListener('beforeunload', handleBeforeUnload);
			handleCallEnd();
		};
	}, []);


	const myMeeting = async (element) => {
		// const appID = 278626295;
		// const serverSecret = "cba897987fc459da6c0b147950e6c7bf";
		// generate Kit Token
		const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(appID, serverSecret, roomId, user?._id, user?.name);

		// Create instance object from Kit Token.
		const zc = ZegoUIKitPrebuilt.create(kitToken);

		// start the meeting
		zc?.joinRoom({
			container: element,
			// showRoomTimer: true,
			sharedLinks: [
				{
					name: 'Copy link',
					// url:
					//  window.location.protocol + '//' + 
					//  window.location.host + window.location.pathname +
					//   '?roomId=' +
					//   roomId,
					url: `${meetingUrl}/room/${roomId}`
				},
			],
			scenario: {
				mode: ZegoUIKitPrebuilt.GroupCall, // To implement 1-on-1 calls, modify the parameter here to [ZegoUIKitPrebuilt.OneONoneCall].
			},
		});
	}

	return (
		<>
			<div className="roomContainer">
				{/* Improved header */}
				<div className="roomHeader">
					<Link to="/" className="btn btn-sm btn-secondary">
						<i className="fa fa-arrow-left"></i> Back to Chat
					</Link>
				</div>

				{/* Call container - full screen */}
				<div
					className="myCallContainer"
					ref={myMeeting}
					style={{ width: '100%', height: '100vh' }}
				>
				</div>

				{/* Room ID badge - bottom right corner */}
				<div className="roomIdBadge">
					Room: {roomId}
				</div>
			</div>

			{/*<!-- Modal -->*/}
			<Modal show={ViewLoginModel}
				// onHide={hanldeDndModelClose}
				backdrop="static"
				keyboard={false}
				className="loginRoomModal"
			>
				<h4 className="mb-3">Log-In</h4>
				<form onSubmit={loginUser} className="col-md-12 col-sm-6 col-12 mx-auto">
					<div className="mb-3">
						<input type="email" name="email" className="form-control" placeholder="Email" value={email} onChange={handleInputChange} />
					</div>
					<div className="mb-3 passwordField">
						<input type={show ? "text" : "password"} name="password" className="form-control" placeholder="Password" value={password} onChange={handleInputChange} />
						<button type="button" onClick={showPassword}>{show ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}</button>
					</div>

					<button type="submit" className="btn btn-secondary">
						{isLoading === true ? (
							<PulseLoader color="#fff" size={16} />
						) : (
							'Login'
						)}
					</button>
				</form>
			</Modal>
		</>
	)
}

export default Room